import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  rescheduleClassesCurrentFiltersSelector,
  RESCHEDULE_CLASSES_FILTERS,
  setRescheduleFilterValue,
} from 'features/classCreation';
import { FILTER_TYPE } from 'data/filterType';
import Field from 'components/Field';
import InstructorSelect from 'components/InstructorSelect';

function RescheduleClassesInstructorsFilter() {
  const dispatch = useDispatch();
  const { primaryInstructors, secondaryInstructors } = useSelector(
    rescheduleClassesCurrentFiltersSelector
  );
  const _styles = {
    control: (styles, state) => ({
      ...styles,
      padding: '0.1rem',
    }),
  };

  const handlePrimaryInstructorsChange = useCallback(
    (option) => {
      dispatch(
        setRescheduleFilterValue({
          key: RESCHEDULE_CLASSES_FILTERS.primaryInstructors,
          value: option,
          type: FILTER_TYPE.current,
        })
      );
    },
    [dispatch]
  );

  const handleSecondaryInstructorsChange = useCallback(
    (option) => {
      dispatch(
        setRescheduleFilterValue({
          key: RESCHEDULE_CLASSES_FILTERS.secondaryInstructors,
          value: option,
          type: FILTER_TYPE.current,
        })
      );
    },
    [dispatch]
  );

  return (
    <>
      <Field
        label="Primary Instructor Name"
        labelClassName="h5"
        className="m-t-xs"
      >
        <InstructorSelect
          isMulti
          value={primaryInstructors}
          placeholder="Select primary instructor"
          styles={_styles}
          className="m-b-s"
          onChange={handlePrimaryInstructorsChange}
        />
      </Field>
      <Field
        label="Secondary Instructor Name"
        labelClassName="h5"
        className="m-t-xs"
      >
        <InstructorSelect
          isMulti
          value={secondaryInstructors}
          placeholder="Select secondary instructor"
          styles={_styles}
          className="m-b-s"
          onChange={handleSecondaryInstructorsChange}
        />
      </Field>
    </>
  );
}

export default RescheduleClassesInstructorsFilter;
